import React, { useEffect, useState } from "react";
import { ClientsTableRow } from "./clientsTableRow";

export const ClientsTable = ({
	data,
	setClientToEdit,
	deleteClient,
	openModal,
}) => {
	const [showData, setShowData] = useState(data);

	useEffect(() => {
		setShowData(data);
	}, [data]);

	function handleSearch(e) {
		if (e.target.value === "") {
			return setShowData(data);
		}
		setShowData(
			data.filter(
				(item) =>
					item.client.toLowerCase().includes(e.target.value) ||
					item.IdNumber.toLowerCase().includes(e.target.value)
			)
		);
	}

	return (
		<div>
			<div className="document-search">
				<h2 className="title-search">Buscar</h2>
				<input
					type="search"
					name=""
					id=""
					onChange={handleSearch}
					className="search-box"
				/>
			</div>
			<h3 className="titulo1">Lista de Clientes</h3>
			<table className="tabla-procesos">
				<thead>
					<tr className="fila-tabla-procesos">
						<th className="titleTableDocuments03">Tipo Id</th>
						<th className="titleTableDocuments03">Número Id</th>
						<th className="titleTableDocuments02">Cliente</th>
						<th className="titleTableDocuments03">Acción</th>
					</tr>
				</thead>
				<tbody>
					{showData.length > 0 ? (
						showData.map((el) => (
							<ClientsTableRow
								key={el.id}
								el={el}
								setClientToEdit={setClientToEdit}
								openModal={openModal}
								deleteClient={deleteClient}
							/>
						))
					) : (
						<tr>
							<td colSpan="3">Sin datos</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
